module.exports = __webpack_public_path__ + "img/08-0学术会议管理.0f095d86.png";